export const UserValidation = (formData) => {
  const errors = {};
  
  
  if (!formData.formData.UserName.trim()) {
    errors.UserName = 'Email  is required';
  } 

  if (!formData.formData.DisplayName.trim()) {
    errors.DisplayName = 'Display Name is required';
  }

  if (!formData.formData.Email.trim()) {
    errors.Email = 'User Name  is required';
  } else if (!isValidEmail(formData.formData.Email)) {
    errors.Email = 'Please enter a valid email address';
  }

  if (!formData.formData.UserPassword.trim()) {
    errors.UserPassword = 'User Password  is required';
  }
  if (!formData.formData.ConfirmPassword.trim()) {
    errors.ConfirmPassword = 'Confirm Password  is required';
  }
  if (formData.formData.UserPassword.trim() !== formData.formData.ConfirmPassword.trim()) {
    errors.ConfirmPassword = 'Passwords do not match';
  }
  if (formData.formData.UserID != "60") {
    if (formData.formData.TeamID === "0") {
      errors.TeamID = 'Please Select Team';
    }
    if (formData.formData.RoleID === "0") {
      errors.RoleID = 'Please Select Role';
    }
  }


  // Add more validations as needed for other fields

  return errors;
};

const isValidEmail = (email) => {
  // You can implement a regex or use a library like validator.js to validate email format
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};